import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { AgGridEvent, ColumnApi, GridApi, GridOptions } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { ImageGalleryService } from '../image-gallery-container-service.component';
import { SpecialServiceFormatterComponent } from './../formatters/special-service-formatter';

@Component({
  selector: 'app-related-pros',
  templateUrl: './related-pros.component.html',
  styleUrls: ['./related-pros.component.scss'],
})
export class RelatedProsComponent implements OnInit, OnDestroy {
  @Input() relatedProsList: any;
  private gridApi: GridApi;
  private colApi: ColumnApi;
  sizeToFit: boolean = true;
  imageSubscription: Subscription;

  frameworkComponents = {
    SpecialServiceFormatterComponent: SpecialServiceFormatterComponent,
  };

  gridOptions: GridOptions = {
    suppressHorizontalScroll: true,
    frameworkComponents: this.frameworkComponents,
    headerHeight: 40,
  };

  columnDefs = [
    {
      headerName: 'Pro #',
      field: 'proNbr',
      width: 110,
      minWidth: 110,
      suppressSizeToFit: false,
      valueGetter: (params) => {
        const eraseFirstCero = params.data.proNbr ? params.data.proNbr.replace(/^0/, '') : '';
        const proNbrWithSpace = !!params
          ? `${eraseFirstCero.slice(0, 3)}-${eraseFirstCero.slice(3).replace(/^0/, '')}`
          : '';
        return proNbrWithSpace;
      },
      suppressMenu: true,
    },
    {
      headerName: 'Origin',
      field: 'originSic',
      width: 100,
      suppressSizeToFit: false,
      suppressMenu: true,
    },
    {
      headerName: 'Destination',
      field: 'destSic',
      width: 100,
      suppressSizeToFit: false,
      suppressMenu: true,
    },
    {
      headerName: 'MM',
      field: 'motorMoves',
      width: 100,
      suppressSizeToFit: false,
      suppressMenu: true,
    },
    {
      headerName: 'Weight',
      field: 'weight',
      width: 115,
      suppressSizeToFit: false,
      suppressMenu: true,
    },
    {
      headerName: 'Util.(%)',
      field: 'utilization',
      width: 110,
      suppressSizeToFit: false,
      suppressMenu: true,
    },
    {
      headerName: 'Date/Time',
      field: 'loadedTimestamp',
      width: 150,
      minWidth: 150,
      suppressSizeToFit: false,
      suppressMenu: true,
      valueGetter: (params) => {
        return params.data.loadedTimestamp ? params.data.loadedTimestamp.replace(/-/g, '/') : '';
      },
    },
    {
      headerName: 'Type',
      field: 'utilization',
      width: 120,
      valueGetter: (params) => {
        const { guaranteedInd, frzblInd, hazmatInd, misloadInd } = params.data;
        return { guaranteedInd, frzblInd, hazmatInd, misloadInd };
      },
      cellRenderer: 'SpecialServiceFormatterComponent',
      suppressSizeToFit: false,
      suppressMenu: true,
    },
  ];

  constructor(private imageGalleryService: ImageGalleryService) {}

  onFirstDataRendered(params) {
    params.api.sizeColumnsToFit();
  }

  ngOnInit() {
    this.imageSubscription = this.imageGalleryService.sidePanelStatus$.subscribe(() => {
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
      }, 0);
    });
  }

  @HostListener('window:resize', ['$event'])
  sizeChange() {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  onGridReady(gridEvent: AgGridEvent) {
    this.gridApi = gridEvent.api;
    this.colApi = gridEvent.columnApi;
    this.sizeChange();
  }

  ngOnDestroy() {
    this.imageSubscription.unsubscribe();
  }
}
